import React, { useEffect, useState } from 'react'
import ReviewConfirmationView from './components/ReviewConfirmationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const ReviewConfirmation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('review-confirmation', 'Make a Restitution Payment', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <ReviewConfirmationView setIsError={setIsError} />
}

export default withTranslation('common')(ReviewConfirmation)
